import { render } from "./NavbarCenterItem.vue?vue&type=template&id=fd18b8ae&scoped=true&ts=true"
import script from "./NavbarCenterItem.vue?vue&type=script&lang=ts"
export * from "./NavbarCenterItem.vue?vue&type=script&lang=ts"

import "./NavbarCenterItem.vue?vue&type=style&index=0&id=fd18b8ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd18b8ae"]])

export default __exports__